import api from "src/spintr/SpintrApi";
import { SpintrTypes } from "src/typings";

export interface IGroupMemberSearchParams {
    groupId: number;
    searchText: string;
    take?: number;
    skip?: number;
}

export const respondToInvite = async (inviteId: number, accept: boolean): Promise<any> => {
    const url = `/api/v1/groupmembers/${inviteId}`;

    const responsePromise = accept
        ? api.put(url)
        : api.delete(url);

    const response = await responsePromise;

    return response.data;
};

export const respondToRequest = async (userId: number, groupId: number, accept: boolean): Promise<any> => {
    const url = `/api/v1/groupmembers/request/${groupId}/${accept ? "accept" : "reject"}/${userId}`;

    const response = await api.post(url);

    return response.data;
};

export const searchGroupMembers = async (params: IGroupMemberSearchParams): Promise<Spintr.ISocialUser[]> => {
    const response = await api.get("/api/v1/groupmembers", {
        params: {
            groupId: params.groupId,
            isAscending: true,
            orderByColumn: "instanceId",
            searchText: params.searchText,
            take: params.take ?? 10,
            skip: params.skip ?? 0,
        },
    });

    return (response.data?.members ?? []).filter(member => member.status >= SpintrTypes.GroupMembershipStatus.Member);
};

export const GroupsApi = {
    respondToInvite,
    respondToRequest,
    searchGroupMembers,
};

export default GroupsApi;